module.exports = __webpack_public_path__ + "img/Donate.2050644a.svg";